<template lang="pug">
  ListLayout(
    :title='$route.meta.title'
  )
    ItemList(
      type='playlists'
      :items='[playlistWithFavoritesTracks, ...playlists]'
      :creator='creator'
    )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import paginationPage from "@/mixins/pages/pagination.mixin";
import errorHandler from "@/services/errorHandler";

import { mapGetters, mapActions } from "vuex";

const strategy = async function(route, ctx) {
  try {
    const { tracks = [] } = await PageLoader.getFavoriteTracks();

    ctx.favoriteTracksIds = tracks.map(track => track.id);
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "PlaylistsPage",
  mixins: [paginationPage(strategy)],
  data() {
    return {
      favoriteTracksIds: []
    };
  },
  computed: {
    ...mapGetters({
      playlists: "playlists/playlistsArray"
    }),
    creator() {
      return {
        label: this.$l10n("CREATE_PLAYLIST"),
        action: () => this.create()
      };
    },
    playlistWithFavoritesTracks() {
      return {
        id: "favorites",
        title: this.$l10n("I_LIKE"),
        type: "favorites",
        tracks: this.favoriteTracksIds
      };
    }
  },
  methods: {
    ...mapActions({
      create: "playlists/create"
    })
  }
};
</script>
